/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import ImageLoader from 'react-render-image';
import LinkIcon from '@atlaskit/icon/core/migration/link';
import { gs } from './utils';
/**
 * Class name for selecting non-flexible block card icon image
 *
 * @deprecated {@link https://hello.jira.atlassian.cloud/browse/ENGHEALTH-6878 Internal documentation for deprecation (no external access)}
 * Using this selctor is deprecated as once the flexible block card feature flag is removed, this class will no longer be used.
 */
export var blockCardIconImageClassName = 'block-card-icon-image';
var getImageStyles = function getImageStyles(isFlexibleUi) {
  if (isFlexibleUi) {
    return;
  }
  return css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: gs(2),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: gs(2)
  });
};
var getSpanStyles = function getSpanStyles(isFlexibleUi) {
  if (isFlexibleUi) {
    return;
  }
  return css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: gs(2.5),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: gs(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  });
};
export var IconOld = function IconOld(_ref) {
  var url = _ref.url,
    icon = _ref.icon,
    defaultIcon = _ref.defaultIcon,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'block-card-icon' : _ref$testId,
    _ref$isFlexibleUi = _ref.isFlexibleUi,
    isFlexibleUi = _ref$isFlexibleUi === void 0 ? false : _ref$isFlexibleUi;
  var placeholder = defaultIcon || jsx(LinkIcon, {
    label: "link",
    LEGACY_size: "small",
    testId: "".concat(testId, "-default"),
    color: "currentColor"
  });
  var image = url && jsx(ImageLoader, {
    src: url,
    loaded: jsx("img", {
      // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
      css: getImageStyles(isFlexibleUi),
      src: url,
      alt: "",
      "data-testid": "".concat(testId, "-image")
    }),
    errored: placeholder
  });
  return jsx("span", {
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    css: getSpanStyles(isFlexibleUi),
    "data-testid": testId
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: blockCardIconImageClassName
  }, icon || image || placeholder);
};